import { render, staticRenderFns } from "./DetailPK.vue?vue&type=template&id=3f5b35e6&scoped=true"
import script from "./DetailPK.vue?vue&type=script&lang=js"
export * from "./DetailPK.vue?vue&type=script&lang=js"
import style0 from "./DetailPK.vue?vue&type=style&index=0&id=3f5b35e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5b35e6",
  null
  
)

export default component.exports